import React from "react";

import { Text } from "@performyard/py-components";

import { GeneratedContentContainer } from "./GeneratedContentContainer";
import { ImprovementCard, type ImprovementCardState } from "./ImprovementCard";

type ImprovementsContainerProps = {
	suggestionStates: ImprovementCardState[];
	onApply: (suggestionId: string) => void;
	onDelete: (suggestionId: string) => void;
};

/** "Suggested Improvements" block shared by the goal and form building coaches. */
export const ImprovementsContainer: React.FC<ImprovementsContainerProps> = ({
	suggestionStates,
	onApply,
	onDelete,
}) => {
	const visibleSuggestions = suggestionStates.filter((s) => s.status !== "deleted");
	const allRemoved = visibleSuggestions.length === 0;

	return (
		<GeneratedContentContainer title="Suggested Improvements">
			{allRemoved ? (
				<Text size="paragraph-3" color="neutral-7">
					All suggested improvements have been removed.
				</Text>
			) : (
				<div className="flex flex-col gap-3">
					{visibleSuggestions.map((s) => (
						<ImprovementCard
							key={s.suggestion.id}
							suggestionState={s}
							onApply={() => onApply(s.suggestion.id)}
							onDelete={() => onDelete(s.suggestion.id)}
						/>
					))}
				</div>
			)}
		</GeneratedContentContainer>
	);
};

export default ImprovementsContainer;
